module.exports = __webpack_public_path__ + "img/icon_location_busy.f8bf096c.png";